export enum CachedItemType {
	Template = "template",
    Field = "field",
    User = "user"
}
